import { WebUser } from "@prisma/client";
import { map } from "nanostores";

export const $account = map({
  isLoggedIn: false,
  user: null as unknown as WebUser,
});
